import { createReducer } from "../../common/reduxUtil";
import { CURRENCY_TYPE, DURATION_TYPE } from "../common/constants";
import {
  RESET_ALL_STATES,
  SET_IS_APPLY_MODAL_ACTIVE,
  SET_IS_JOB_SAVED,
  SET_IS_ORGANIZATION_ADMIN,
  SET_JOB_APPLICATION,
  SET_JOB_ID,
  SET_JOB_PAYLOAD,
} from "./types";

const initialState = {
  jobId: null,
  job: null,
  isApplyModalActive: false,
  isAdmin: false,
  isJobSaved: false,
  jobApplication: {
    portfolioLinks: [""],
    currentCTC: {
      currency: CURRENCY_TYPE.INR,
      value: null,
    },
    expectedCTC: {
      currency: CURRENCY_TYPE.INR,
      value: null,
    },
    currency: {
      label: Object.keys(CURRENCY_TYPE)[0],
      value: CURRENCY_TYPE.INR,
    },
    noticePeriod: {
      type: DURATION_TYPE.Month,
      value: null,
    },
    noticeDurationType: {
      label: Object.keys(DURATION_TYPE)[3],
      value: DURATION_TYPE.Month,
    },
    location: null,
    resume: {},
    stage: 0,
  },
};

export default createReducer(initialState, {
  [SET_IS_APPLY_MODAL_ACTIVE]: (state, payload) => {
    return Object.assign({}, state, {
      isApplyModalActive: payload.value,
    });
  },
  [SET_JOB_ID]: (state, payload) => {
    return Object.assign({}, state, {
      jobId: payload.value,
    });
  },
  [RESET_ALL_STATES]: (state) => {
    return Object.assign({}, state, {
      ...initialState,
    });
  },
  [SET_JOB_APPLICATION]: (state, payload) => {
    return Object.assign({}, state, {
      jobApplication: { ...state.jobApplication, ...payload.value },
    });
  },
  [SET_JOB_PAYLOAD]: (state, payload) => {
    return Object.assign({}, state, payload, {
      job: payload.value,
    });
  },
  [SET_IS_ORGANIZATION_ADMIN]: (state, payload) => {
    return Object.assign({}, state, payload, {
      isAdmin: payload.value,
    });
  },
  [SET_IS_JOB_SAVED]: (state, payload) => {
    return Object.assign({}, state, payload, {
      isJobSaved: payload.value,
    });
  },
});
